import {
  mdiViewDashboard,
  mdiPageLayoutBody,
  mdiAccount,
  mdiCog,
  mdiShieldCheck,
  mdiPalette,
  mdiHelpCircleOutline,
  // mdiFrequentlyAskedQuestions,
  mdiBookOpenPageVariant,
  mdiLifebuoy,
  mdiHistory
} from '@mdi/js'

export default [
  {
    title: 'General',
    items: [
      {
        label: 'Dashboard',
        to: '/customer/dashboard',
        icon: mdiViewDashboard
      },
      {
        label: 'Landing Page Saya',
        to: '/customer/landing-pages',
        icon: mdiPageLayoutBody
      }
    ]
  },
  {
    title: 'Setting',
    items: [
      {
        label: 'Pengaturan',
        icon: mdiCog,
        menu: [
          {
            label: 'Profil Saya',
            to: '/customer/profile',
            icon: mdiAccount
          },
          {
            label: 'Keamanan Akun',
            to: '/customer/settings/security',
            icon: mdiShieldCheck
          },
          {
            label: 'Tampilan',
            to: '/customer/settings/appearance',
            icon: mdiPalette
          },
          {
            label: 'Aktivitas Log',
            to: '/customer/settings/activity',
            icon: mdiHistory
          }
        ]
      }
    ]
  },
  {
    title: 'Bantuan',
    items: [
      {
        label: 'Pusat Bantuan',
        icon: mdiHelpCircleOutline,
        menu: [
          {
            label: 'Panduan',
            to: '/customer/help/guide',
            icon: mdiBookOpenPageVariant
          },
          {
            label: 'Hubungi Support',
            to: '/customer/help/support',
            icon: mdiLifebuoy
          }
        ]
      }
    ]
  }
]